export const candidateData = {
    data() {
        return {
            genders: ['Man', 'Vrouw', 'Ik weet het nog niet'],
            knownFroms: ['UWV', 'Gemeente', 'Workfix.nl', 'Indeed','Indeed Campagne','Facebook','Instagram','Recruit Robin','Kennis','Werkzoeken.nl','Werkzoeken.nl Campagne','Jobmatix Campagne','LinkedIn'],
            knownFromOthers: ['Iemand die er al werkt', 'Vrienden', 'Visistekaartje', 'Van horen'],
            languages: ['Nederlands', 'Engels'],
            languagesOther: ['Duits', 'Pools', 'Frans', 'Italiaans', 'Spaans'],
            certificatesArray: [],
            disabledDates: {
                to: new Date(new Date().setDate(new Date().getDate() - 1))
            },
        }
    }
}